import { useEffect, useState } from 'react';
import axios from 'axios';
import { useI18n } from '@/i18n';

export const CONSENT_API = `${process.env.REACT_APP_BACKEND_URL}/api/booking-consent`;

export function useBookingConsent(scope, eventId, bookingIdentity, enabled = true) {
  const {lang} = useI18n();
  const [policy,setPolicy] = useState(null);
  const [proof,setProof] = useState(null);
  const [error,setError] = useState('');
  const [generation,setGeneration] = useState(0);
  useEffect(()=>{
    let active=true;
    setPolicy(null);setProof(null);setError('');
    if (!enabled) return ()=>{active=false;};
    axios.get(`${CONSENT_API}/policy/${scope}/${encodeURIComponent(eventId)}`,{params:{language:lang}})
      .then(r=>{if(active)setPolicy({...r.data,bookingIdentity});})
      .catch(()=>{if(active)setError('The photography consent document is unavailable. Please try again later.');});
    return ()=>{active=false;};
  },[scope,eventId,bookingIdentity,lang,enabled,generation]);
  const ready=enabled&&policy?.language===lang&&policy?.scope===scope&&policy?.bookingIdentity===bookingIdentity;
  const checked=Boolean(ready&&proof&&proof.document_hash===policy.document_hash);
  const setChecked=value=>{
    if(!value||!ready){setProof(null);return;}
    setProof({accepted:true,version:policy.version,event_id:policy.event_id,language:lang,
      document_hash:policy.document_hash,acceptance_id:crypto.randomUUID()});
  };
  const reload=()=>{setProof(null);setPolicy(null);setGeneration(n=>n+1);};
  return {policy:ready?policy:null,checked,setChecked,submission:checked?proof:null,error,reload};
}